module.exports = __webpack_public_path__ + "static/media/down-arrow.2911ce70.svg";